module.exports = __webpack_public_path__ + "img/arrow_buyfeature_normal.83bb974c.png";